export default "__VITE_ASSET__DmOGMOgs__"